import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GDPRCookie from "../components/GDPRCookie"; // Import GDPR Cookie component
import LoadTop from "../components/LoadTop";
import HomeOne from "./HomeOne";
import HomeTwo from "./HomeTwo";
import HomeThree from "./HomeThree";
import HomeFour from "./HomeFour";
import HomeFive from "./HomeFive";
import HomeSix from "./HomeSix";
import HomeSeven from "./HomeSeven";
import HomeDark from "./HomeDark";
import HomeVideo from "./HomeVideo";
import About from "./About";
import Resturant from "./Resturant";
import Gallery from "./Gallery";
import Service from "./Service";
import Event from "./Event";
import Activities from "./Activities";
import Contact from "./Contact";
import RoomOne from "./RoomOne";
import RoomTwo from "./RoomTwo";
import RoomThree from "./RoomThree";
import RoomFour from "./RoomFour";
import RoomDetails from "./RoomDetails";
import RoomDetailsTwo from "./RoomDetailsTwo";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import Cart from "./Cart";
import CheckOut from "./CheckOut";

function RouterPage() {
  return (
    <>
      <Router>
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeOne />} />
          <Route path="/home-2" element={<HomeTwo />} />
          <Route path="/home-3" element={<HomeThree />} />
          <Route path="/home-4" element={<HomeFour />} />
          <Route path="/home-5" element={<HomeFive />} />
          <Route path="/home-6" element={<HomeSix />} />
          <Route path="/home-7" element={<HomeSeven />} />
          <Route path="/home-dark" element={<HomeDark />} />
          <Route path="/home-video" element={<HomeVideo />} />
          <Route path="/about" element={<About />} />
          <Route path="/resturant" element={<Resturant />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/service" element={<Service />} />
          <Route path="/event" element={<Event />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/room-one" element={<RoomOne />} />
          <Route path="/room-two" element={<RoomTwo />} />
          <Route path="/room-three" element={<RoomThree />} />
          <Route path="/room-four" element={<RoomFour />} />
          <Route path="/room/:id" element={<RoomDetails />} />
          <Route path="/room2/:id" element={<RoomDetailsTwo />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<CheckOut />} />
        </Routes>

        {/* GDPR Cookie Consent Component */}
        <GDPRCookie 
          settings={{
            title: "We use cookies",
            message: "This site uses cookies to improve your experience. You can customize your preferences.",
            expires: 90, // Cookie expiration in days
            cookieName: "userCookiePrefs",
            acceptBtnLabel: "Accept All Cookies",
            advancedBtnLabel: "Manage Preferences",
            cookieTypes: [
              { type: "Essential", value: "essential", description: "Necessary for site functionality", checked: true },
              { type: "Preferences", value: "preferences", description: "Saves your site preferences", checked: true },
              { type: "Analytics", value: "analytics", description: "Helps us improve site usage", checked: false },
              { type: "Marketing", value: "marketing", description: "Personalized advertising", checked: false },
            ]
          }}
        />
      </Router>
    </>
  );
}

export default RouterPage;
